import React from 'react'
import { Tooltip } from 'antd'
import { StartResearchButton, StartResearchSlot } from '../../styles/MindMapHeaderStyles'

interface StartResearchRoundButtonProps {
  /** When false the button is greyed out and a tooltip explains why. */
  enabled: boolean
  /** True when this button is the left half of the split-button (no shadow, sliced radius). */
  attached?: boolean
  onClick: () => void
}

const DISABLED_TOOLTIP =
  'Add some needs and ideas to your mindmap before starting a research round.'

export const StartResearchRoundButton: React.FC<StartResearchRoundButtonProps> = ({
  enabled,
  attached = false,
  onClick,
}) => {
  const disabled = !enabled

  const button = (
    <StartResearchButton type="button" onClick={onClick} disabled={disabled} $attached={attached}>
      <span>Start research round</span>
    </StartResearchButton>
  )

  if (!disabled) return button

  return (
    <Tooltip title={DISABLED_TOOLTIP} placement="bottom">
      {/* Antd Tooltip cannot bind hover to a disabled <button>; wrap it. */}
      <StartResearchSlot>{button}</StartResearchSlot>
    </Tooltip>
  )
}
